import { createExternalRouteRef } from '@backstage/frontend-plugin-api';

export const settingsRouteRef = createExternalRouteRef();

export const catalogEntityRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
});

export const externalRoutes = {
  catalogEntityRouteRef,
  settingsRouteRef,
};
